// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge_badge_3Z4Jf","user":"badge_user_1glru","faculty":"badge_faculty_2DJDi"};